import { daysWaiting } from "encamp-shared/src/submissions/waitingSince";

/** " ⏳ 12d" after a waited-on customer reviewer's name, or nothing when the wait is undated. */
export function waitingDaysSuffix(waitingSince: string | null | undefined): string {
  return longestWaitingDaysSuffix([waitingSince]);
}

/** {@link waitingDaysSuffix} for the longest of several waits. */
export function longestWaitingDaysSuffix(
  waitingSinces: ReadonlyArray<string | null | undefined>
): string {
  const earliest = waitingSinces
    .flatMap((since) => (since ? [new Date(since)] : []))
    .reduce<Date | null>((min, since) => (min === null || since < min ? since : min), null);
  return earliest ? ` ⏳ ${daysWaiting(earliest)}d` : "";
}
